import type React from 'react';

interface SendIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function SendIcon({ size = 24, ...props }: SendIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.4385 7.2167L3.26135 3.08669C2.87782 2.90515 2.46005 3.02834 2.2409 3.27472C1.98749 3.54054 1.9327 3.93603 2.09707 4.26021L4.17223 7.99472L2.09707 11.7552C1.92585 12.0793 1.98749 12.4748 2.23405 12.7082C2.39842 12.8898 2.65182 13 2.91207 13C3.0285 13 3.14492 12.9741 3.2545 12.9222L13.4385 8.79219C13.7741 8.66252 14.0001 8.33835 14.0001 7.98175C13.9727 7.64461 13.7536 7.34637 13.4385 7.22318V7.2167ZM11.3839 8.50043L3.26135 11.82L5.08311 8.50043H11.3839ZM11.3976 7.48252H5.08311L3.26135 4.20834L11.3908 7.48901L11.3976 7.48252Z"
        fill="currentColor"
      />
    </svg>
  );
}
